import { render, staticRenderFns } from "./CaGuzhu.vue?vue&type=template&id=1fd6a2d0&"
import script from "./CaGuzhu.vue?vue&type=script&lang=js&"
export * from "./CaGuzhu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports